export enum MixpanelEvents {
  PAGE_VIEWED = 'Page viewed',
  CLIENT_CREATED = 'Client created',
  FAMILY_CREATED = 'Family created',
  SIESTA_MESSAGE_SENT = 'Siesta message sent',
  SIESTA_SUGGESTION_REQUESTED = 'Siesta suggestion requested',
  DATA_UPLOAD_FILE_UPLOADED = 'Data upload file uploaded',
  DATA_UPLOAD_FILE_PROCESS_CLICK = 'Data upload file process click',
  DATA_UPLOAD_FILE_PROCESS_COMPLETE = 'Data upload file process complete',
  DATA_UPLOAD_FILE_SET_RESOLVED = 'Data upload file set resolved',
  DATA_UPLOAD_FILE_DOCUMENT_FILED = 'Data upload file document filed',
  SUITABILITY_REPORT_FLOW_STARTED = 'Suitability report flow started',
  SUITABILITY_REPORT_FLOW_CLIENT_SELECTED = 'Suitability report flow client selected',
  SUITABILITY_REPORT_FLOW_TEMPLATE_SELECTED = 'Suitability report flow template selected',
  SUITABILITY_REPORT_FLOW_ADVICE_DOCUMENTS_SELECTED = 'Suitability report flow advice documents selected',
  SUITABILITY_REPORT_FLOW_APPENDICES_SELECTED_AND_GENERATE = 'Suitability report flow appendices selected and generate',
  USER_CREATED = 'User created',
  USER_DELETED = 'User deleted',
  USER_UPDATED = 'User updated',
}
